export const classicGames = [
  {
    title: "XO Arena",
    subtitle: "Tic Tac Toe",
    copy: "Fast skill rounds, quick rematches, and instant board play.",
    to: "/xogame",
    image: "/img/bonus.jpeg",
    amount: "Skill PvP",
  },
  {
    title: "RPS Arena",
    subtitle: "Rock Paper Scissors",
    copy: "Head-to-head picks, fast entry, and live settle rooms.",
    to: "/rps",
    image: "/img/spin-win.jpeg",
    amount: "Quick Match",
  },
  {
    title: "Chess Club",
    subtitle: "Classic Strategy",
    copy: "Longer matches, invite play, and computer practice tables.",
    to: "/chess",
    image: "/img/win-bt.jpeg",
    amount: "Strategy PvP",
  },
  {
    title: "Omi House",
    subtitle: "Card Table",
    copy: "Create a four-seat house, share a room code, and play live team rounds.",
    to: "/omi",
    image: "/img/casino.png",
    amount: "4 Seat Table",
  },
];
